// Per-row status pill for the import preview tables (ready / exists / error).
// Receives `t` as a prop so it stays a tiny presentational helper with no hook of its own.
export function StatusBadge({
  status,
  t,
}: {
  status: "ready" | "exists" | "error";
  t: (k: string) => string;
}) {
  const map = {
    ready: { label: t("import.fileStep.statusReady"), cls: "bg-green-bg text-green-dark" },
    exists: { label: t("import.fileStep.statusExists"), cls: "bg-warning-bg text-warning" },
    error: { label: t("import.fileStep.statusError"), cls: "bg-red-bg text-red" },
  };
  const { label, cls } = map[status];
  return (
    <span className={`rounded-pill px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{label}</span>
  );
}
